var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 273,
    height: 283.508,
    viewBox: "0 0 273 283.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.186,
    x2: 1.186,
    y1: -1.485,
    y2: -1.485,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2bc5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2bc5b4",
    stopOpacity: 0.471
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.144,
    x2: -1.144,
    y1: -2.217,
    y2: -2.217,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#24afa0}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7219",
    transform: "translate(-189.539 -217.275)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_375",
    cx: 55.418,
    cy: 55.418,
    r: 55.418,
    fill: "url(#linear-gradient)",
    opacity: 0.3,
    transform: "translate(206.517 371.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    cx: 35.716,
    cy: 35.716,
    r: 35.716,
    fill: "url(#linear-gradient-2)",
    opacity: 0.3,
    transform: "translate(300.146 291.206)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7214",
    transform: "translate(251.751 217.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    d: "M510.213 262.354l-36.327-42.338c-.069-.08-.141-.158-.215-.232a8.64 8.64 0 0 0-11.711-.429l-28.947 24.995a8.5 8.5 0 0 0-.878 11.984l1.133 1.313-1.867 1.612c-4.955 4.28-12.413 5.56-19.947 3.423-.153-.043-21.592-6.128-21.747-6.164-3.908-.908-14.017-2.342-23.673 3.887-.156.089-55.477 31.752-55.627 31.85-5.049 3.29-12.083 11.514-6.411 21.47l.068.115a14.248 14.248 0 0 0 10.024 6.979 15.016 15.016 0 0 0 26.353 9.22l20.5-23.691a14.924 14.924 0 0 0 2.088-3.143l.846-.349c1.105 4.145 4.127 8.27 10.3 10.021 25.726 7.3 31.081 9.41 38.284 8.614 20.08-2.152 24.682-2.811 34.8-8.631a159.526 159.526 0 0 0 21.1-14.573l1.233 1.428a8.495 8.495 0 0 0 11.985.878l27.554-23.793a10.278 10.278 0 0 0 1.082-14.446zM334.161 324.6a6.71 6.71 0 0 1-11.765-4.608l24.539-10.151zm108.957-18.942c-8.6 4.953-11.5 5.423-31.451 7.562-5.464.586-9.745-1.111-35.219-8.336-3.263-.925-4.115-2.67-4.472-3.9a7.877 7.877 0 0 1-.178-3.291c0-.019 0-.039.009-.058.008-.036.018-.071.025-.107a6.363 6.363 0 0 1 .978-2.087c.619-.835 1.551-1.648 3.78-1.341 7.859 1.081 26.574 3.584 26.762 3.609a4.154 4.154 0 0 0 1.1-8.234c-.188-.025-18.887-2.525-26.731-3.6a12.077 12.077 0 0 0-13.375 7.806l-6.058 2.5c-47.814 19.714-37.034 15.435-40.583 16.459-6.679.937-11.256-7.754-2.857-13.357l55.4-31.715.012-.006c.067-.039.133-.079.2-.121a22.794 22.794 0 0 1 17.27-2.846l21.454 6.085c10.23 2.9 20.565.983 27.642-5.128l1.867-1.612L462.93 292a151.149 151.149 0 0 1-19.812 13.659zm60.582-35.147c-.088.076-27.578 23.853-27.693 23.839-.159-.012-37.816-43.5-37.568-43.712l28.947-25a.3.3 0 0 1 .357-.025l36.163 42.146a1.954 1.954 0 0 1-.206 2.752z",
    className: "cls-3",
    transform: "translate(-301.891 -217.275)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7216",
    transform: "translate(189.539 383.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    d: "M388.934 531.013c-.5-13.394-17.4-19.561-26.352-9.219l-20.506 23.692a14.877 14.877 0 0 0-2.086 3.142l-.846.349c-1.105-4.145-4.127-8.271-10.3-10.021-27.234-7.724-30.784-9.273-38.2-8.621l-.08.008c-20.08 2.153-24.683 2.811-34.8 8.631a159.458 159.458 0 0 0-21.1 14.574l-1.233-1.428a8.506 8.506 0 0 0-11.985-.878l-29.057 25.088a8.22 8.22 0 0 0-.807 11.65l38.295 43.64a8 8 0 0 0 11.108.923l.077-.065 28.947-25a8.492 8.492 0 0 0 .878-11.984l-1.133-1.313 1.867-1.612c4.956-4.28 12.414-5.559 19.947-3.423l19.26 5.462a4.153 4.153 0 1 0 2.267-7.991l-19.261-5.463c-10.231-2.9-20.564-.984-27.642 5.127l-1.867 1.612-24.232-28.063a151.079 151.079 0 0 1 19.812-13.661c8.612-4.956 11.5-5.424 31.5-7.567 4.674-.407 7.6.435 23.618 5.037 12.415 3.566 14.978 3.584 16.026 7.2a7.879 7.879 0 0 1 .178 3.291 6.166 6.166 0 0 1-1.012 2.253c-.62.834-1.555 1.647-3.78 1.341-7.86-1.081-26.574-3.584-26.762-3.609a4.154 4.154 0 0 0-1.1 8.234c.188.025 18.887 2.525 26.731 3.6a12.057 12.057 0 0 0 13.372-7.805c.207-.085 41.826-17.239 42.026-17.338 4.387-2.227 8.531-2.737 11.144 1.458 3.007 5.374-2.326 9.384-3.669 10.28l-55.4 31.714-.074.043c-.044.026-.094.057-.136.085a21.127 21.127 0 0 1-2.909 1.581 4.153 4.153 0 0 0 3.388 7.584 29.413 29.413 0 0 0 3.954-2.14c.164-.094 55.463-31.744 55.622-31.848 15.056-9.797 7.811-26.71-3.688-28.55zM264.6 600.926a.176.176 0 0 1 .046.138c-.009.122-28.618 24.783-28.71 24.863l-38.054-43.366 28.994-25.035a.177.177 0 0 1 .137-.046.173.173 0 0 1 .13.066zm91.487-58.937l12.774-14.76a6.709 6.709 0 0 1 11.764 4.608z",
    className: "cls-3",
    transform: "translate(-189.539 -516.603)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7218",
    transform: "translate(292.593 332.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    d: "M404.746 439.083a6.937 6.937 0 0 0 5.783 3.141 6.775 6.775 0 0 0 5.445-3.2 11.1 11.1 0 0 1 19.884 1.166 4.154 4.154 0 0 0 7.64-3.263 19.387 19.387 0 0 0-33.136-4.351c-11.367-14.564-34.728-6.29-34.711 12.01.02 19.241 16.68 33.956 32.266 41.312a5.8 5.8 0 0 0 4.953-.005c11.206-5.316 23.119-14.75 28.632-26.142a4.153 4.153 0 1 0-7.477-3.619c-4.492 9.282-14.442 17.095-23.644 21.731-12.963-6.41-26.407-18.339-26.422-33.286-.011-11.27 15.114-15.477 20.787-5.494z",
    className: "cls-3",
    transform: "translate(-375.65 -425.097)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain1);
export default __webpack_public_path__ + "static/media/retain1.15cc9f280a42c07074f8e3dc6703969e.svg";
export { ForwardRef as ReactComponent };